import { lazy, Suspense, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import { trackPageView } from "../services/analytics";
const NotFound = lazy(() => import("../pages/NotFound"));

const RouteAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pathWithQuery = `${location.pathname}${location.search}`;
    trackPageView(pathWithQuery);
  }, [location.pathname, location.search]);

  return null;
};

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <RouteAnalyticsTracker />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
